module.exports = __webpack_public_path__ + "1_0_64/img/add_member.4c926530.svg";